import {createContext,useContext,useEffect,useState} from 'react';
import axios from 'axios';
import {Navigate} from 'react-router-dom';
import {WebteraLogo} from '../components/WebteraLogo';
import './branding.css';

const Context=createContext({brand:null,loading:true});
export const useBranding=()=>useContext(Context);
export const BrandingProvider=({children})=>{
  const [brand,setBrand]=useState(null),[loading,setLoading]=useState(true);
  useEffect(()=>{
    let alive=true;
    if(window.location.pathname.startsWith('/owner')){setLoading(false);return;}
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/branding`,{params:{host:window.location.hostname},timeout:10000})
      .then(({data})=>{
        if(alive&&data.branded){
          setBrand(data);
          document.title=data.name || 'Webtera';
        } else if (alive) {
          document.title='Webtera';
        }
      })
      .catch(()=>{if(alive)document.title='Webtera';})
      .finally(()=>{if(alive)setLoading(false);});
    return()=>{alive=false;};
  },[]);
  if(brand&&!brand.active&&!window.location.pathname.startsWith('/owner'))return <main className="tenant-unavailable" data-testid="brokerage-unavailable"><h1>{brand.name}</h1><p>{brand.kind==='admin'?'Bu kurumun erişimi geçici olarak durduruldu.':'This brokerage is temporarily unavailable.'}</p></main>;
  return <Context.Provider value={{brand,loading}}>{children}</Context.Provider>;
};

export const BrandedHome=()=>{const {brand,loading}=useBranding();if(loading)return <div className="tenant-brand-loading" data-testid="brokerage-brand-loading">…</div>;const isTrader = brand?.kind==='trader' || (typeof window !== 'undefined' && window.location.hostname.includes('trade'));return <Navigate to={isTrader?'/trader':'/admin'} replace/>;};

export const TenantBrand=({fallback=null,id='tenant-brand',compact=false})=>{
  const {brand}=useBranding();
  if(!brand)return fallback || <WebteraLogo compact={compact} size={28} subtitle={compact?'':'TRADING'} />;
  const initials=brand.name.split(/\s+/).slice(0,2).map(value=>value[0]).join('').toUpperCase();
  return <span className={`tenant-brand${compact?' is-compact':''}`} data-testid={id} title={brand.name}>{brand.logo_id?<img data-testid={`${id}-logo`} src={`${process.env.REACT_APP_BACKEND_URL}/api/branding/logo/${encodeURIComponent(brand.logo_id)}`} alt={`${brand.name} logo`}/>:<span className="tenant-brand-initials" aria-hidden="true">{initials}</span>}<span className="tenant-brand-name" data-testid={`${id}-name`}>{brand.name}</span></span>;
};